export default {
    'memberAreaPointsHistory.title': 'Activity Points',
    'memberAreaPointsHistory.point_detail': 'Points Details',
    'memberAreaPointsHistory.event_name': 'Event Name',
    'memberAreaPointsHistory.placeholder.event': 'Please enter the event name',
} as Record<string, string>;
